import React, { Component } from 'react'
import './WithdrawalComplete.scss'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import HeaderProject from '../../Components/Commons/HeaderProject'

class WithdrawalComplete extends Component {
    render() {
        return (
            <div>
                {this.props.cookies.get('project') ? <HeaderMenu /> : <HeaderProject />}
                <div className="section_wrap">
                    <div className="withdrawal_complete_wrap">
                        <div className="complete_box common_wrap">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                width="86"
                                height="86"
                                viewBox="0 0 86 86">
                                <defs>
                                    <linearGradient id="b" x1="50%" x2="50%" y1="52.02%" y2="98.817%">
                                        <stop offset="0%" stopColor="#DDE0E7" />
                                        <stop offset="100%" stopColor="#E0E1E5" />
                                    </linearGradient>
                                    <circle id="a" cx="43" cy="43" r="43" />
                                    <path
                                        id="e"
                                        d="M35.62 52.724h17.76c12.426 0 22.499 10.073 22.499 22.498l-33.723 31.886L13.12 75.222c0-12.425 10.073-22.498 22.498-22.498z"
                                    />
                                    <filter
                                        id="d"
                                        width="111.2%"
                                        height="112.9%"
                                        x="-5.6%"
                                        y="-4.6%"
                                        filterUnits="objectBoundingBox">
                                        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                                        <feGaussianBlur
                                            in="shadowOffsetOuter1"
                                            result="shadowBlurOuter1"
                                            stdDeviation="1"
                                        />
                                        <feColorMatrix
                                            in="shadowBlurOuter1"
                                            values="0 0 0 0 0.564705882 0 0 0 0 0.6 0 0 0 0 0.670588235 0 0 0 0.1 0"
                                        />
                                    </filter>
                                    <path
                                        id="g"
                                        d="M43.526 49C52.116 49 59 42.077 59 33.5S52.117 18 43.526 18C34.935 18 28 24.923 28 33.5S34.935 49 43.526 49z"
                                    />
                                    <filter
                                        id="f"
                                        width="122.6%"
                                        height="122.6%"
                                        x="-11.3%"
                                        y="-8.1%"
                                        filterUnits="objectBoundingBox">
                                        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                                        <feGaussianBlur
                                            in="shadowOffsetOuter1"
                                            result="shadowBlurOuter1"
                                            stdDeviation="1"
                                        />
                                        <feColorMatrix
                                            in="shadowBlurOuter1"
                                            values="0 0 0 0 0.564705882 0 0 0 0 0.6 0 0 0 0 0.670588235 0 0 0 0.1 0"
                                        />
                                    </filter>
                                    <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="99.133%">
                                        <stop offset="0%" stopColor="#D1D4DB" />
                                        <stop offset="100%" stopColor="#D2D4DB" />
                                    </linearGradient>
                                    <circle id="h" cx="43" cy="43" r="43" />
                                </defs>
                                <g fill="none" fillRule="evenodd">
                                    <mask id="c" fill="#fff">
                                        <use xlinkHref="#a" />
                                    </mask>
                                    <use fill="url(#b)" xlinkHref="#a" />
                                    <g mask="url(#c)">
                                        <use fill="#000" filter="url(#d)" xlinkHref="#e" />
                                        <use fill="#F7F9FD" xlinkHref="#e" />
                                    </g>
                                    <g mask="url(#c)">
                                        <use fill="#000" filter="url(#f)" xlinkHref="#g" />
                                        <use fill="#F7F9FD" xlinkHref="#g" />
                                    </g>
                                    <circle cx="43" cy="43" r="42.5" stroke="url(#i)" />
                                    <g stroke="#DADEE7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5">
                                        <path d="M50 27L37 40M37 27l13 13" />
                                    </g>
                                </g>
                            </svg>

                            <h1>하우스플래너 탈퇴가 완료되었습니다!</h1>
                            <h2>하우스플래너를 이용해주셔서 감사합니다.</h2>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(WithdrawalComplete)



// WEBPACK FOOTER //
// ./Src/Containers/User/WithdrawalComplete.js